"use client";

import clsx from "clsx";
import Link from "next/link";
import { usePathname } from "next/navigation";

export function NavLink({ href, children }: { href: string; children: JSX.Element | string }) {
	const pathname = usePathname();

	const isActive = pathname === href;

	return (
		<li className="inline-flex">
			<Link
				href={href}
				className={clsx(
					// Quiet uppercase gallery nav; active/hover marked by a thin gold underline, not a heavy border.
					"label-caps inline-flex items-center border-b pb-0.5 pt-px transition-colors duration-300 ease-gallery",
					isActive
						? "border-mg-gold-deep text-mg-black"
						: "border-transparent text-ink-muted hover:text-mg-black",
				)}
			>
				{children}
			</Link>
		</li>
	);
}
